(() => {
  'use strict';
  const root = document.querySelector('[data-loa-five-reasons]');
  if (!root) return;
  const incoming = new URLSearchParams(window.location.search);
  const allowed = ['loa_exp','loa_arm','loa_visitor','loa_path','utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'msclkid', 'ttclid'];
  const links = root.querySelectorAll('[data-loa-five-reasons-cta]');
  links.forEach(link => {
    const destination = new URL(link.href, window.location.origin);
    allowed.forEach(key => {
      const value = incoming.get(key);
      if (value && value.length <= 1024 && value.toLowerCase() !== key) destination.searchParams.set(key, value);
    });
    link.href = destination.href;
  });
  const sent = new Set();
  function publish(name, details = {}, once = false) {
    const shopify = window.Shopify;
    if (!shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || !shopify?.analytics?.publish) return false;
    if (once && sent.has(name)) return true;
    try {
      const result = shopify.analytics.publish(`loa_five_reasons:${name}`, {
        surface: 'v4_presell_six_reasons', version: '2026-09-09',
        internal_qa: incoming.get('utm_source') === 'internal_qa', ...details
      });
      if (result?.catch) result.catch(() => {});
      if (once) sent.add(name);
      return true;
    } catch (_) { return false; }
  }
  let offerVisible = false;
  function ready() {
    publish('page_view', {}, true);
    if (offerVisible) publish('offer_view', {}, true);
  }
  links.forEach(link => link.addEventListener('click', () => {
    publish('cta_click', { placement: link.dataset.loaFiveReasonsCta, destination: 'v4_sales_b' });
  }));
  const offer = root.querySelector('[data-loa-five-reasons-offer]');
  if (offer && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      offerVisible = entries.some(entry => entry.isIntersecting);
      if (offerVisible) ready();
    }, { threshold: 0.15 }).observe(offer);
  }
  document.addEventListener('visitorConsentCollected', ready);
  document.addEventListener('customerPrivacyApiLoaded', ready);
  window.addEventListener('load', ready, { once: true });
  ready();
  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) ready(); });
  }
})();
